import leaderboardImg from '../../assets/images/leaderboard_table_only.png';

export default function Benchmarks() {
  return (
    <section className="py-20 bg-[#F8FAFF]">
      <div className="max-w-[1200px] mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-12">
          <p className="text-[#546FFF] text-sm font-semibold tracking-widest uppercase mb-3">
            MODEL COMPARISON
          </p>
          <h2 className="text-3xl md:text-4xl font-bold text-[#080808] mb-4">
            State-of-the-art VLM
          </h2>
          <p className="text-[#08080899] text-lg max-w-[600px] mx-auto">
            Leading industry benchmarks like OlmOCR, OmniDoc, IDP Core, outperforming all big-three models and open-source alternatives.
          </p>
        </div>

        {/* Benchmark image */}
        <div className="flex flex-col items-center gap-4">
          <img
            src={leaderboardImg}
            alt="Document parsing and extraction benchmarks — Nanonets vs GPT-4o, Claude, Gemini"
            className="w-full max-w-[900px] rounded shadow-sm"
            loading="lazy"
            decoding="async"
          />
          <p className="text-sm text-[#08080866] max-w-[900px] text-center">
            Our open-source model Nanonets-OCR2-Plus achieves global SOTA across industry-standard document processing benchmarks, outperforming all big-three models and open-source alternatives.
          </p>
        </div>
      </div>
    </section>
  );
}
